import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useAxios from "../../../hook/useAxios";
import BreadCrumb from "../../Global/BreadCrumb";
import Loading from "../../Global/Loading";
import DepartmentTab from "./DepartmentTab/DepartmentTab";
import MunicipalityTab from "./MunicipalityTab/MunicipalityList/MunicipalityTab";

const ViewDepartment = () => {
  const { t } = useTranslation();
  const { id } = useParams<any>();
  const [tab, setTab] = useState<string>("province");

  const {
    fetchData: getDepartments,
    response: breadCrumb,
    loading,
  } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/departments/${id}/edit/`,
    "GET",
    false,
    "",
    true,
    true,
  );

  useEffect(() => {
    getDepartments({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="parent-container">
      <h1 className="font-semibold text-default-text text-[16px] mt-5">
        {t("Province.View province")}
      </h1>
      <BreadCrumb
        breadcrumb={[
          { name: t("Navbar.Settings"), url: "" },
          { name: t("Navbar.Provinces"), url: "/setting/provinces" },
          { name: `${breadCrumb?.data?.name}`, url: "" },
          { name: t("Province.View province"), url: "" },
        ]}
      />
      {loading ? (
        <Loading loading={true} />
      ) : (
        <div className="flex flex-wrap flex-col mt-4">
          <div className="flex flex-row cursor-pointer">
            <button
              className={`${
                tab === "province"
                  ? "text-ph-btn border-2 border-ph-white bg-ph-white rounded-t-[8px]"
                  : "text-default-text border-2 border-ph-map-bg"
              } py-4 px-2 h-[57px] w-[117px] text-[14px] text-center`}
              onClick={() => setTab("province")}
            >
              {t("Navbar.Provinces")}
            </button>
            <button
              className={`${
                tab === "municipality"
                  ? "text-ph-btn border-2 border-ph-white bg-ph-white rounded-t-[8px]"
                  : "text-default-text border-2 border-ph-map-bg"
              } py-4 px-2 h-[57px] w-[117px] text-[14px] text-center`}
              onClick={() => setTab("municipality")}
            >
              {t("Navbar.Municipalities")}
            </button>
          </div>
          <div className="bg-ph-white flex">
            {tab === "province" ? (
              <DepartmentTab id={id} />
            ) : (
              <MunicipalityTab id={id} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewDepartment;
